import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import LazyGoogleAuth from "./components/LazyGoogleAuth";

import "./styles/global.scss";
import "bootstrap/dist/css/bootstrap.min.css";

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <LazyGoogleAuth clientId="1013016136996-gbsgi5u4co0meo5m2dmof85sdgg6cgk3.apps.googleusercontent.com">
    <React.StrictMode>
        <App />
    </React.StrictMode>
  </LazyGoogleAuth>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
